<div class="flex-fill">
  <mat-sidenav-container class="flex-fill" [dir]="dir">
    <mat-sidenav
      #sidenav
      class="sidenav-bar"
      [mode]="isMobile ? 'over' : 'side'"
      [opened]="!isMobile"
      [disableClose]="!isMobile"
      ngClass.gt-sm="has-border"
    >
      <mat-toolbar color="light" class="top-left-bar my-1">
        <img
          [src]="'assets/flyplus/app-logo.svg' | assets"
          class="side-menu-logo"
        />
        <div class="flex-fill"></div>
      </mat-toolbar>
      <div class="px-3">
        <div class="ahoy-divider"></div>
      </div>
      <nav class="px-3">
        <div class="text-muted fs-13 fw-500" translate>Section</div>
        <mat-list class="side-menu-options mb-3 mt-2">
          @for (item of sectionMenuOptions; track item) {
            <a
              class="mb-1 c-pointer"
              @slide
              mat-list-item
              [routerLink]="item.link"
              routerLinkActive="active"
              (click)="isMobile && sidenav.close()"
            >
              <div class="d-flex">
                <img routerLinkActive="disappear" [src]="item.icon" />
                <img
                  class="disappear"
                  routerLinkActive="appear"
                  [src]="item.icon"
                />
                <span translate class="fs-13 fw-500">{{ item.label }}</span>
                <span
                  class="{{ item.badge == 'NEW' ? 'badge-new' : 'badge' }}"
                  translate
                  >{{ item.badge }}</span
                >
              </div>
            </a>
          }
        </mat-list>
        <div class="text-muted fs-13 fw-500" translate>Other</div>
        <mat-list class="side-menu-options mb-3 mt-2">
          @for (item of otherMenuOptions; track item) {
            <a
              class="mb-1 c-pointer"
              @slide
              mat-list-item
              [routerLink]="item.link"
              routerLinkActive="active"
              (click)="isMobile && sidenav.close()"
            >
              <div class="d-flex">
                <img routerLinkActive="disappear" [src]="item.icon" />
                <img
                  class="disappear"
                  routerLinkActive="appear"
                  [src]="item.icon"
                />
                <span translate class="fs-13 fw-500">{{ item.label }}</span>
                <span
                  class="{{ item.badge == 'NEW' ? 'badge-new' : 'badge' }}"
                  translate
                  >{{ item.badge }}</span
                >
              </div>
            </a>
          }
        </mat-list>
      </nav>
      @if (poweredByUrl) {
        <div class="side-menu-footer mt-3">
          <img [src]="poweredByUrl" class="" />
        </div>
      }
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar
        color="light"
        class="content-toolbar mat-elevation-z0 top-bar"
      >
        <button class="menu-button" mat-icon-button (click)="sidenav.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
        <app-breadcrumb></app-breadcrumb>

        <div class="flex-fill"></div>
        <div class="headers">
          <div class="user-profile align-items-center">
            <!-- could be needed in future -->
            <div class="language-selection align-self-center">
              <div class="content" [matMenuTriggerFor]="languageMenu">
                <h5 class="selected-lang">
                  @if (currentLanguage === 'en-US') {
                    <div class="fs-13">
                      <mat-icon class="mat-icon-xs text-muted"
                        >language</mat-icon
                      >
                      <!-- <img src="https://flagcdn.com/24x18/us.png" alt="" /> -->
                      &nbsp; EN
                    </div>
                  }
                  @if (currentLanguage !== 'en-US') {
                    <div class="fs-13">
                      <mat-icon class="mat-icon-xs text-muted"
                        >language</mat-icon
                      >
                      <!-- <img src="https://flagcdn.com/24x18/sa.png" alt="" /> -->
                      &nbsp; AR
                    </div>
                  }
                </h5>
                <mat-icon>expand_more</mat-icon>
              </div>
            </div>
            <img
              [matMenuTriggerFor]="userMenu"
              src="{{
                profileDetails?.imgUrl
                  ? profileDetails?.imgUrl
                  : 'assets/sgs-dashboard/customer-profile.png'
              }}"
              alt=""
              class="user-image"
            />
            <mat-menu #userMenu="matMenu">
              <app-setting-menu
                [profileInfo]="profileDetails"
                [locale]="currentLanguage"
                (localeChange)="changeLanguage({ value: $event })"
              ></app-setting-menu>
            </mat-menu>
            <!-- could be needed in future -->
            <mat-menu #languageMenu="matMenu">
              <button
                mat-menu-item
                value="ar"
                (click)="changeLanguage({ value: 'en-US' })"
                translate
              >
                &nbsp; English
              </button>
              <button
                mat-menu-item
                value="en-US"
                (click)="changeLanguage({ value: 'ar' })"
                translate
              >
                &nbsp; العربية
              </button>
            </mat-menu>
          </div>
          <!-- <div
            class="d-flex c-pointer align-items-center"
            [matMenuTriggerFor]="userMenu"
          >
          
            <div
              mat-ripple
              [matRippleCentered]="true"
              [matRippleRadius]="100"
              class="user-avatar"
            >
              <img
                [src]="
                  profileDetails?.imgUrl
                    ? profileDetails?.imgUrl
                    : 'assets/sgs-dashboard/customer-profile.png'
                "
              />
            </div>
          </div> -->
        </div>
      </mat-toolbar>
      <div class="content-container">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
@if (enableChatbot) {
  <app-chatbot></app-chatbot>
}
